import { useContext, useMemo } from 'react';

import { UserPreferencesContext } from '../userPreferenceContext';
import { deriveEffectiveTaxonomiesForScope } from '../utils/derive-effective-taxonomies';

export function useSkillTaxonomy(): number | undefined {
  const { preferences, scope } = useContext(UserPreferencesContext);

  const selection = useMemo(() => {
    // The merged view stores the raw GLOBAL choice; derive it for this page's
    // scope first so a non-company 'adaptive' resolves to Generic instead of
    // reading a company-page adaptive resolution (or staying undefined).
    const taxonomies =
      deriveEffectiveTaxonomiesForScope(preferences.taxonomies, scope) || {};
    const skillPref = taxonomies?.skill;
    const effectiveSkillPref = taxonomies?.effectiveSkillTaxonomySelection;

    if (!skillPref) return 0;

    if (skillPref === 'adaptive') {
      // When adaptive, use the effective selection if available (computed
      // by adaptive taxonomy hooks). Return undefined while unresolved so
      // callers that can handle it (like useCustomSkillTaxonomyTree) can
      // decide whether to pause or fall back to default.
      if (typeof effectiveSkillPref === 'number' && effectiveSkillPref > 0) {
        return effectiveSkillPref;
      }
      return undefined;
    }

    if (typeof skillPref === 'number') return skillPref;
    return 0;
  }, [preferences, scope]);

  return selection;
}
